import axios from 'axios'
import { Platform } from 'react-native'
import { actionTypes, ACTION_NAMES } from '@adalo/constants'
import { getPayload } from './jwt'
import { unsafeGetToken } from '../ducks/auth'
import { getScreenSize } from './responsive'

const PRODUCTION_URL = 'https://analytics.adalo.com'

const getAnalyticsURL = () => {
  const analyticsURL =
    process.env.NODE_ENV === 'production'
      ? PRODUCTION_URL
      : process.env.REACT_APP_ANALYTICS_URL

  return analyticsURL
}

export const isPWA = () => {
  try {
    const hasAndroidReferrer = document
      ? document?.referrer?.includes?.('android-app://')
      : false

    const isStandalonePWA =
      window?.matchMedia?.('(display-mode: standalone)').matches ||
      window?.navigator?.standalone ||
      hasAndroidReferrer

    return isStandalonePWA
  } catch (error) {
    return false
  }
}

window.isPWA = isPWA

export const logEvent = (event, app, component, metadata = {}, opts = {}) => {
  window.setTimeout(async () => {
    const url = getAnalyticsURL()

    const appId = app.id
    const token = getPayload(unsafeGetToken(null, app))

    if (!url || opts.disableAnalytics) {
      return
    }

    const { userId } = token || {}
    const additional = { Screen: component && component.name }

    if (event === actionTypes.NAVIGATE) {
      const { target } = metadata
      const screen = app.components[target]

      if (screen) {
        additional['Target Screen'] = screen.name
      } else {
        event = 'Link Back'
      }
    }

    if (opts.appVersion) {
      additional.appVersion = opts.appVersion
    }

    const eventName = ACTION_NAMES[event] || event

    let platform = Platform.OS

    if (platform === 'web') {
      if (isPWA()) {
        platform = 'web-pwa'
      }
    }

    const windowWidth = getScreenSize().width
    const windowHeight = getScreenSize().height
    const windowSize = { width: windowWidth, height: windowHeight }
    let device

    if (windowWidth <= 767) {
      device = 'mobile'
    } else if (windowWidth > 767 && windowWidth <= 1024) {
      device = 'tablet'
    } else {
      device = 'desktop'
    }

    await axios.post(`${url}/events`, {
      appId,
      userId,
      event: eventName,
      metadata: {
        ...additional,
        platform,
        windowSize,
        device,
        afterAppActions: true,
      },
    })
  }, 0)
}

export const identifyUser = async (appId, user) => {
  const url = getAnalyticsURL()

  if (!url) {
    return
  }

  const { id, name, email } = user

  await axios.post(`${url}/users`, {
    appId,
    name,
    email,
    userId: id,
  })
}
